import { render, staticRenderFns } from "./addservice.vue?vue&type=template&id=61cf54dc&scoped=true"
import script from "./addservice.vue?vue&type=script&lang=js"
export * from "./addservice.vue?vue&type=script&lang=js"
import style0 from "./addservice.vue?vue&type=style&index=0&id=61cf54dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf54dc",
  null
  
)

export default component.exports